/*eslint-disable*/
import React from "react";
import { language } from "config";

import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";
import ProductSection from "./Sections/ProductSection";
import classNames from "classnames";

import { makeStyles } from "@material-ui/core";

import image2 from "assets/api_images/5-load-page-image-transparent_fullpage-blue-redline-top.png";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "dark",
        }}
        {...rest}
      />
      <Parallax filter image={image2}>
        <div className={classes.container}>
          <GridContainer spacing={2}>
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <br />
              <h1 className={classes.title}>{language.landing_slogan}</h1>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ProductSection />
        </div>
      </div>

      <Footer />
    </div>
  );
}
